import { TVideoType } from '@/shared/types/media';

/** Русские названия типов видео */
export const VIDEO_TYPES: Record<TVideoType, string> = {
  video_business_card: 'Видеовизитка',
  portfolio_showreel: 'Портфолио (Шоурил)',
  episode: 'Эпизод из фильма',
  interview: 'Интервью',
  music_video: 'Видеоклип',
  short_film: 'Короткометражка',
  audition: 'Пробы',
  advertisement: 'Реклама',
  poetry: 'Стихи',
  theatre_audition: 'Театральные пробы',
  trailer: 'Трейлер фильма',
  other: 'Прочее'
};

/**
 * Минимальная ширина фото подтверждения личности, px (19243): 3:4-кроп из
 * прежнего минимума 400×600 давал 400×533 и не проходил по высоте. Одно
 * значение на бэке (`User#validate_system_photo_dimensions`), вебе и мобилке
 */
export const MIN_SYSTEM_PHOTO_WIDTH = 480;

/** Минимальная высота фото подтверждения личности, px (19243) */
export const MIN_SYSTEM_PHOTO_HEIGHT = 640;
